export default __webpack_public_path__ + "static/media/Patron Vambraces.950fdf93.jpg";